import { useState, useEffect } from "react"
import { removeEmptyFromObject } from "../../services/utils/removeEmptyFromObject"
import { sorts } from "../../services/utils/sorts"
import { useInfinitePagination } from "./useInfinitePagination"
import nodeApiService from "../../services/nodeApiService"

export const useExhibitionsActions = (
  _exhibitions,
  searchTerm = null,
  withGalleryFeatured = false,
) => {
  const [exhibitions, setExhibitions] = useState(_exhibitions)
  const _sorts = sorts.exhibitions
  const [sort, setSort] = useState("createddesc")
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState(searchTerm)
  const { loadingMore, setPage, setShouldCall } = useInfinitePagination(
    (page) => callApi(page),
    (response) =>
      setExhibitions({
        ...exhibitions,
        data: [...exhibitions.data, ...response.data],
      }),
  )

  const callApi = (page) => {
    const body = removeEmptyFromObject({
      page,
      order: sort,
      search,
      withGalleryFeatured: withGalleryFeatured ? true : undefined,
    })
    if (Object.keys(body).length !== 0) {
      return nodeApiService.exhibitions(body)
    }
  }

  useEffect(() => {
    if (search !== null || sort !== null) {
      setPage(1)
      setLoading(true)
      setShouldCall(true)
      callApi().then((response) => {
        setExhibitions(response.data)
        setLoading(false)
      })
    }
  }, [search, sort])

  return {
    exhibitions,
    setSearch,
    loading,
    sort,
    setSort,
    sorts: _sorts,
    loadingMore,
  }
}
